import React, { useState } from "react";
import Modal from "react-modal";
import Burn_Chart from "./Burn_Chart.js";
import { sendGetRequest } from '../../../../Helper/helper';

const BurnTrackerModal = ({ modalIsOpen, closeModal }) => {
  const [fullData, setFullData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleModalOpen = async () => {
    setLoading(true);
    try {
      const response = await sendGetRequest('historical/burn/chart', 'GET');
      if (response && response.status === 200) {
        setFullData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Modal"
      onAfterOpen={handleModalOpen}
    >
      <div className="My__Overlay ">
        <div className="My__OverlayIn px-0">
          <div className="PTGCSEC popupcenter">
            <div className="container">
              {loading ? (
                <div className="py-5">
                  <div className="text-center pb-5">
                    <div className="text-center pb-2">
                      <span className="loaderChart"></span>
                    </div>
                    Loading...
                  </div>
                </div>
              ) : (
                <>
                  <button
                    className="nobg closepopup d-flex align-items-center gap-1"
                    onClick={closeModal}
                  >
                    <span className="underline">Close</span>
                    <img src="./images/XCircle.svg" className="img-fluid" alt="Close" />
                  </button>

                  <div className="text-center">
                    <h2 className="mb-0 mt-2 w-100 good_times goldFont">
                      Burn Tracker
                    </h2>
                  </div>

                  <div className="row justify-content-center mt-4">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <div className="">
                        <div className="bSRIN overHide">
                          <div
                            className="bSRIN snstakes overHide mt-0 w-5100"
                            style={{
                              border: '0px',
                              borderRadius: '0px',
                              borderBottom: '0px solid #383835',
                            }}
                          >
                            <Burn_Chart fullData={fullData} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BurnTrackerModal;
